<template>
	<svg
		id="Layer_1"
		data-name="Layer 1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		width="25px"
		height="25px"
		:class="{ 'cashout-indicator': 1, 'cashout-indicator--valid': canCashout }"
		v-if="$store.getters['cashout/whitelisted']"
	>
		<path
			d="M396.65,114.36a149.16,149.16,0,0,0-115-13.47c73.68,51.3,97.65,151.48,52.58,231.16a174.84,174.84,0,0,1-51.46,56.74c64.73,18,136-9.32,170.49-70.37,40.65-71.87,15.25-163.41-56.62-204.06Z"
		/>
		<path
			d="M179.44,93a151,151,0,1,0,151,151A151,151,0,0,0,179.44,93ZM129.91,271.71c9.09,0,16.5-4.21,20.56-12.6h26.29c-5.59,21.26-23.21,34.27-46.57,34.27-28.95,0-49.37-20.56-49.37-49.93s20.42-50.07,49.37-50.07c23.36,0,41,13.15,46.57,34.41H150.47c-4.06-8.39-11.47-12.59-20.56-12.59-14.69,0-24.76,10.91-24.76,28.25S115.22,271.71,129.91,271.71Zm108,22c-27.84,0-50.49-20.84-50.49-50.34S210.11,193.1,238,193.1s50.21,20.7,50.21,50.22S265.78,293.66,238,293.66Z"
		/>
		<path
			d="M238,214.78c-15.95,0-26,11.05-26,28.54,0,17.19,10.07,28.52,26,28.52,15.66,0,25.87-11.33,25.87-28.52C263.82,225.83,253.61,214.78,238,214.78Z"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		betAmount: {
			type: Number,
			required: true,
		},
		totalOdds: {
			type: Number,
			required: true,
		},
		liveMatches: {
			type: Boolean,
			required: true,
		},
		areThereAnyInvalidMatches: {
			type: Boolean,
			required: true,
		},
		possibleWinnings: {
			type: Number,
			required: true,
		},
		bets: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			canCashout: false,
			cashoutMessage: null,
		};
	},
	watch: {
		totalOdds(n, o) {
			if (n) this.checkIfCanCashout();
		},
	},
	mounted() {
		this.checkIfCanCashout();
	},
	computed: {
		rules() {
			return this.$store.getters["cashout/settings"];
		},
	},
	methods: {
		betValidForCashout(sportID, subTypeID) {
			if (!this.rules || this.rules.length == 0) return false;

			const validSports = this.rules.find((rule) => rule.rule_name == "sport")
				.rule_values;

			const validMarkets = this.rules.find(
				(rule) => rule.rule_name == "sub_type_id"
			).rule_values;

			return (
				validSports.indexOf(sportID) > -1 &&
				validMarkets.indexOf(subTypeID) > -1
			);
		},
		checkIfCanCashout() {
			let canCashout = true;
			let vm = this;
			vm.bets.forEach((bet) => {
				canCashout &= vm.betValidForCashout(bet.odd.sport_id, bet.sub_type_id);
			});
			vm.canCashout = canCashout;
		},
		checkIfCanCashoutFromAPI() {
			let vm = this;
			vm.cashoutMessage = null;
			if (this.areThereAnyInvalidMatches) {
				vm.canCashout = false;
				return;
			}
			let bets = vm.bets.map((b) => {
				return {
					bet_pick: b.odd.odd_key,
					parent_match_id: b.odd.parent_match_id.toString(),
					sub_type_id: b.sub_type_id.toString(),
					odd_value: b.odd.odd_value.toString(),
					special_bet_value: b.odd.special_bet_value,
					outcome_id: b.odd.outcome_id,
					reference: b.bet_type == "prebet" ? "PREMATCH_UOF" : "LIVEMATCH_UOF",
				};
			});
			let payload = {
				bet_amount: vm.betAmount,
				total_odd: vm.totalOdds,
				reference: vm.liveMatches ? "LIVEMATCH_UOF" : "PREMATCH_UOF",
				token: vm.$auth.getToken(),
				possible_win: vm.possibleWinnings,
				bet_slips: bets,
			};
			vm.$axios
				.post(`${BASE_V2_URL}cashout/validate`, payload)
				.then((res) => {
					vm.canCashout = res.data.status;
					vm.cashoutMessage = "Cashout will be available for this bet";
				})
				.catch((err) => {
					vm.canCashout = false;
					vm.cashoutMessage = err.response.data.message;
				});
		},
	},
};
</script>

<style lang="scss">
.cashout-indicator {
	fill: var(--light-gray);
	margin: 0 2px;
	&--valid {
		fill: var(--green);
	}
}
</style>
